import React, { useEffect, useState } from "react";
import TopNavBar from "../../../Components/TopNavbar";
import LeftSideNav from "../../../Components/LeftSideNav";
import {
  Paper,
  TableContainer,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Colors from "../../../theme/Colors";
import Strings from "../../../Config/Strings";
import Fonts from "../../../Config/Fonts";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addMenuDetailsAPI } from "../../../Store/Action/menu";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import CustomButton from "../../../Components/CustomButton";

const AddMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    const requestData = {
      menu_title: data?.menu_title,
      menu_slug: data?.menu_slug,
      menu_order: data?.menu_order,
    };
    setLoading(true);
    try {
      await dispatch(
        addMenuDetailsAPI(requestData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success("Menu Added Successfully");
            navigate("/menu");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addMenu:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/menu", text: "Menu" },
      { key: "3", href: "/AddMenu", text: "Add Menu" },
    ]);
  }, []);

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar />

          <div style={pageTitle}>
            <h2>Menu</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <p style={mainHeadingStyle}>Menu</p>

          <hr />

          <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Menu Title</Typography>
                <Controller
                  name="menu_title"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.menuTitleRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Menu Title"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.menu_title}
                      helperText={
                        errors?.menu_title ? errors?.menu_title.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Menu Slug</Typography>
                <Controller
                  name="menu_slug"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.menuSlugRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Menu Slug"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.menu_slug}
                      helperText={
                        errors?.menu_slug ? errors?.menu_slug.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Menu Parent Id</Typography>
                <Controller
                  name="menu_parent_id"
                  control={control}
                  defaultValue=""
                  rules={{ required: Strings.menuSlugRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Menu Parent Id"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.menu_slug}
                      helperText={
                        errors?.menu_slug ? errors?.menu_slug.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Menu Order</Typography>
                <Controller
                  name="menu_order"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: Strings.menuOrderRequired,
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Order must be a number",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Menu Order"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.menu_order}
                      helperText={
                        errors?.menu_order ? errors?.menu_order.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
            </Grid>
          </form>
        </TableContainer>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const pageTitle = {
  marginLeft: "30px",
  justifyContent: "flex-start",
  display: "flex",
};

const tableContainer = {
  width: "70vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "40px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
};

const formStyle = {
  padding: "20px",
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
};

export default AddMenu;
